import { TypeChecker } from '@attain-apps/type-guards'

/**
 * A condition operator. Each maps onto an existing DMS expression function:
 *
 * | operator | DMS expression |
 * | --- | --- |
 * | `equals` | `Equals(GetAttribute(attr), v)` |
 * | `in` | `In(GetAttribute(attr), [...])` |
 * | `notIn` | `Not(In(GetAttribute(attr), [...]))` |
 */
export type Operator = (typeof Operator.ALL)[number]
export namespace Operator {
  export const ALL = ['equals', 'in', 'notIn'] as const
  export const isOperator = TypeChecker.Factory.oneOf(ALL)
}
